module.exports = __webpack_public_path__ + "img/honor_12.8e8410f0.png";